import { __assign, __extends } from "tslib";
/* A modified version of I79 in DS */
import React from 'react';
import IconWrap from '../../../Icons/IconWrap';
var instances = 0;
var GradientCheck = /** @class */ (function (_super) {
    __extends(GradientCheck, _super);
    function GradientCheck() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.instanceId = instances++;
        return _this;
    }
    GradientCheck.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 8 8", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("defs", null,
                    React.createElement("linearGradient", { id: "GradientCheck-G1-" + this.instanceId, gradientTransform: "rotate(45)" },
                        React.createElement("stop", { offset: "0%", stopColor: "#4cddbd" }),
                        React.createElement("stop", { offset: "100%", stopColor: "#06f286" }))),
                React.createElement("path", { d: "M1.237 6.187L0 4.95l1.237-1.238L2.475 4.95l3.712-3.713 1.238 1.238-4.95 4.95-1.238-1.238z", fillRule: "evenodd", fill: "url(#GradientCheck-G1-" + this.instanceId + ")" }))));
    };
    return GradientCheck;
}(React.Component));
export { GradientCheck };
export default GradientCheck;
//# sourceMappingURL=GradientCheckIcon.js.map